import {
  frameThickness,
  glassHingeWidth,
  glassHingeHeight,
  glassLockWidth,
  glassLockHeight,
} from '@/shared/config/model-constants'
import type { ModelData } from '@/shared/stores/model-utils'

export const model2_3InitialModel: ModelData = {
  name: 'Variant 7',
  modelId: 'model2_3',
  type: 'DOOR',
  description: 'Variant 7',
  width: 1600,
  height: 2200,
  photoId: null,
  serviceNames: [],
  serviceIds: [],
  parameters: [
    // Frame profiles
    {
      positionId: 'top_left_frame_profile',
      type: 'PROFILE',
      width: 350,
      height: frameThickness,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 0, y: 0, z: 0 },
    },
    {
      positionId: 'top_right_frame_profile',
      type: 'PROFILE',
      width: 350,
      height: frameThickness,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 1250, y: 0, z: 0 },
    },
    {
      positionId: 'bottom_left_frame_profile',
      type: 'PROFILE',
      width: 350,
      height: frameThickness,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 0, y: 2140, z: 0 },
    },
    {
      positionId: 'bottom_right_frame_profile',
      type: 'PROFILE',
      width: 350,
      height: frameThickness,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 1250, y: 2140, z: 0 },
    },
    {
      positionId: 'left_frame_profile',
      type: 'PROFILE',
      width: frameThickness,
      height: 2200,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 0, y: 0, z: 0 },
    },
    {
      positionId: 'right_frame_profile',
      type: 'PROFILE',
      width: frameThickness,
      height: 2200,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 1540, y: 0, z: 0 },
    },
    // Glass panels
    {
      positionId: 'left_glass_panel',
      type: 'GLASS',
      width: 290,
      height: 2080,
      thickness: 6,
      color: 'rgba(0, 0, 255, 0.1)',
      material: 'clear_glass',
      materialId: null,
      isDouble: false,
      position: { x: frameThickness, y: frameThickness, z: 0 },
    },
   
    {
      positionId: 'door_glass_panel',
      type: 'GLASS',
      width: 900,
      height: 2200,
      thickness: 6,
      color: 'rgba(0, 0, 255, 0.1)',
      material: '',
      materialId: null,
      isDouble: false,
      position: { x: 350, y: 0, z: 0 },
      hardware: {
        handles: [
          {
            positionId: 'right_vertical_handle',
            type: 'VERTICAL_HANDLE',
            width: 40,
            height: 200,
            thickness: 10,
            color: '#ffffff',
            material: '',
            materialId: null,
            position: { x: 30, y: Math.round(2200 * 0.47), z: 10 },
          },
        ],
        hinges: [
          {
            positionId: 'door_2_right_top_hinge_1',
            type: 'HINGE',
            width: glassHingeWidth,
            height: glassHingeHeight,
            thickness: 10,
            color: '#C0C0C0',
            position: {
              x: 900 - glassHingeWidth,
              y: -glassHingeHeight / 2,
              z: 10,
            },
          },
          {
            positionId: 'door_2_right_bottom_hinge_2',
            type: 'HINGE',
            width: glassHingeWidth,
            height: glassHingeHeight,
            thickness: 10,
            color: '#C0C0C0',
            position: {
              x: 900 - glassHingeWidth,
              y: 2200 - glassHingeHeight,
              z: 10,
            },
          },
        ],
        locks: [
          {
            positionId: 'door_2_left_lock',
            type: 'LOCK',
            width: glassLockWidth,
            height: glassLockHeight,
            thickness: 10,
            color: '#C0C0C0',
            position: {
              x: glassLockWidth,
              y: 2200 - glassLockHeight,
              z: 10,
            },
          },
        ],
      },
    },
   
    {
      positionId: 'right_glass_panel',
      type: 'GLASS',
      width: 290,
      height: 2080,
      thickness: 6,
      color: 'rgba(0, 0, 255, 0.1)',
      material: '',
      materialId: null,
      isDouble: false,
      position: { x: 1250, y: frameThickness, z: 0 },
    },
  ],
  doorConfiguration: {
    type: 'single_door',
    totalDoorWidth: 900,
    individualDoorWidth: [900],
    totalHandles: 1,
    openingDirection: 'right_opening',
    hingePosition: 'right',
  },
}
